import * as React from "react";
import * as Progress from "@radix-ui/react-progress";


const initialData = [
  { label: "iOS", percentage: 0, count: 0 },
  { label: "Android OS", percentage: 0, count: 0 },
  { label: "Windows", percentage: 20, count: 0 },
  { label: "OS X", percentage: 0, count: 0 },
  { label: "Linux", percentage: 0, count: 0 },
];

const UserAgentChart = ({ chartData}) => {
  const [data, setData] = React.useState(initialData);

  React.useEffect(() => {
    const mappedData = initialData.map((item) => {
      const foundItem = chartData?.find((chartItem) => chartItem.user_agent.includes(item.label));
      return {
        ...item,
        percentage: foundItem ? foundItem.percentage : 0,
        count: foundItem ? foundItem.count : 0,
      };
    })
    setData(mappedData);
  }, [chartData]);

  return (
    <div className="w-full">
      <h2 className="font-semibold mb-5 font-inter text-[1.125rem] leading-7">OPERATING SYSTEM</h2>
      <div className="flex flex-col gap-3">

      {data.map((item, idx) => (
        <div key={idx} className="flex flex-col gap-[2px]">
          <span className="text-sm font-medium">{item.label}</span>
          <div className="flex gap-2 items-center h-5">
            <Progress.Root
                className="relative h-2 flex-1 overflow-hidden rounded-full bg-[#EAECF0]"
                value={item.percentage}
            >
                <Progress.Indicator
                className="bg-[#FA7415] transition-all w-full h-full rounded-full"
                style={{
                    transform: `translateX(-${100 - item.percentage}%)`,
                }}
                />
            </Progress.Root>
            <span className="text-sm font-medium text-white">
                {item.percentage}% ({item.count})
            </span>
            </div>
        </div>
      ))}
      </div>

    </div>
  );
};

export default UserAgentChart;